(function () {
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    });
  }

  function boot() {
    document.querySelectorAll('.upsell-offer__add-btn').forEach(function (button) {
      button.addEventListener('click', function () {
        var variantId = button.dataset.variantId;
        if (!variantId) return;

        button.disabled = true;
        var originalText = button.textContent;

        addToCart(variantId, 1)
          .then(function () {
            button.textContent = button.dataset.successText || 'Added ✓';
            button.classList.add('upsell-offer__add-btn--added');
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = originalText;
            button.classList.add('upsell-offer__add-btn--error');
            window.setTimeout(function () {
              button.classList.remove('upsell-offer__add-btn--error');
            }, 2000);
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
